export const ALLIANCE_STATUS_LABELS: Record<string, string> = {
  applied: '応募中',
  document_screening: '書類選考中',
  in_progress: '選考中',
  offered: '内定',
  accepted: '承諾',
  candidate_declined: '候補者辞退',
  rejected: '不採用',
};

export const ALLIANCE_NEGATIVE_STATUSES = ['rejected', 'candidate_declined'];

export const isNegativeStatus = (status: string) => ALLIANCE_NEGATIVE_STATUSES.includes(status);
